export const HISTORY_PAGE_TYPES = {
    runs: 'runs',
    versions: 'versions',
};

export const HISTORY_PAGE_TYPES_LABELS = {
    runs: 'Runs',
    versions: 'Versions',
};
